module.exports = __webpack_public_path__ + "components/social-footer/static/facebook-c768382bbdc161e5504419365f784d77.svg";